/**
 * S3 Contracts and Engine tabs. Both are the same shape — a set of blueprint JSON
 * documents — so they share one component driven by a panel descriptor list.
 */

import React from 'react';
import { JsonPanel } from './JsonPanel';
import type { UpdateVersionRequest } from '@/types/aiStudioAgent';

/** Keys of UpdateVersionRequest whose value is a JSON document. */
export type JsonBlueprintField =
  | 'dataSchema'
  | 'outputSchema'
  | 'contextContract'
  | 'engineConfig'
  | 'benchmarkConfig'
  | 'opportunityLogic'
  | 'promotionRules';

export interface JsonPanelDescriptor {
  field: JsonBlueprintField;
  label: string;
}

interface VersionJsonTabProps {
  panels: JsonPanelDescriptor[];
  values: Record<JsonBlueprintField, Record<string, unknown>>;
  /** Shared revision key so every panel resets together after load/save/publish. */
  documentKey: string;
  disabled: boolean;
  onChange: (patch: UpdateVersionRequest) => void;
  onValidityChange: (key: string, valid: boolean) => void;
}

export const VersionJsonTab: React.FC<VersionJsonTabProps> = ({
  panels,
  values,
  documentKey,
  disabled,
  onChange,
  onValidityChange,
}) => (
  <div className="grid gap-4 lg:grid-cols-2">
    {panels.map((panel) => (
      <JsonPanel
        key={panel.field}
        label={panel.label}
        value={values[panel.field]}
        documentKey={`${documentKey}:${panel.field}`}
        disabled={disabled}
        onChange={(value) => onChange({ [panel.field]: value } as UpdateVersionRequest)}
        onValidityChange={(valid) => onValidityChange(panel.field, valid)}
      />
    ))}
  </div>
);
